import { render, staticRenderFns } from "./gj-popover.vue?vue&type=template&id=4639152e&scoped=true&"
import script from "./gj-popover.vue?vue&type=script&lang=js&"
export * from "./gj-popover.vue?vue&type=script&lang=js&"
import style0 from "./gj-popover.vue?vue&type=style&index=0&id=4639152e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4639152e",
  null
  
)

export default component.exports